import type { HomeAnnouncement } from '@/lib/api/home';

function relativeTime(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime();
  const diffMins = Math.floor(diffMs / 60_000);
  if (diffMins < 60) return `${diffMins}m ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays === 1) return 'Yesterday';
  return `${diffDays} days ago`;
}

export function AnnouncementsCard({ announcements }: { announcements: HomeAnnouncement[] }) {
  if (!announcements.length) return null;
  return (
    <section className="rounded-xl border border-[#e8e4df] bg-gradient-to-br from-[#eef4ff] to-white p-6 flex flex-col gap-4 shadow-sm">
      <p className="text-[11px] font-bold uppercase tracking-wide text-[#4a7cfc]">Announcements</p>
      <div className="flex flex-col gap-4">
        {announcements.map((a) => (
          <div key={a.id} className="flex gap-3">
            <span className="size-1.5 shrink-0 rounded-full bg-[#4a7cfc] mt-2" />
            <div className="flex flex-1 items-start justify-between gap-3">
              <span className="text-[#1a1714] text-sm leading-5">{a.content}</span>
              <span className="shrink-0 text-[#9a9589] text-xs leading-5">{relativeTime(a.created_at)}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
